import CustomModal from '../CustomModal';
import classes from './CloseWarningModal.module.scss';

type TCloseWarningModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onOk: () => void;
};

export function CloseWarningModal({
  isOpen,
  onCancel,
  onOk,
}: TCloseWarningModalProps) {
  return (
    <CustomModal.Root
      isOpen={isOpen}
      onClose={onCancel}
      paperClassName={classes['close-modal__paper']}
      scrollMode="modal"
    >
      <CustomModal.Body centered className={classes['close-modal__body']}>
        <div className={classes['close-modal__title']}>
          Вы уверены, что хотите прекратить заполнение?
        </div>
        <div className={classes['close-modal__subtitle']}>
          Введенные данные не сохранятся
        </div>
        <div className={classes['close-modal__buttons-row']}>
          <CustomModal.Button
            type="button"
            onClick={onCancel}
            className={classes['close-modal__continue-form-button']}
            contentClassName={
              classes['close-modal__continue-form-button-content']
            }
          >
            Продолжить
          </CustomModal.Button>
          <CustomModal.Button
            type="button"
            outlined
            onClick={onOk}
            className={classes['close-modal__close-form-button']}
            contentClassName={classes['close-modal__close-form-button-content']}
          >
            Закрыть форму
          </CustomModal.Button>
        </div>
      </CustomModal.Body>
    </CustomModal.Root>
  );
}
